var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "icon-customize" },
    [
      _c("div", { staticClass: "row roomy align-middle margin-bottom-xl" }, [
        _c("div", { staticClass: "column-3 order-last" }, [
          _c("div", { staticClass: "text-right" }, [
            _c(
              "button",
              {
                staticClass:
                  "size-xs flat with-border text-uppercase margin-bottom-0",
                staticStyle: {
                  "--button-background": "transparent",
                  "--border-color": "var(--fa-dk-blue)",
                  "--button-color": "var(--fa-dk-blue)",
                  "letter-spacing": "var(--spacing-6xs)",
                },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.close.apply(null, arguments)
                  },
                },
              },
              [_vm._v("\n          Close Wizard\n        ")]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "column-9" }, [
          _c(
            "h2",
            {
              staticClass: "text-left margin-top-0",
              staticStyle: { color: "var(--fa-navy)", "line-height": "1.2" },
            },
            [
              _c("span", { staticClass: "sr-only" }, [
                _vm._v("Add modifiers to"),
              ]),
              _vm._v(" "),
              _vm.modType == ""
                ? _c("span", [_vm._v(_vm._s(_vm.icon.name))])
                : _c("span", [
                    _c("span", { staticClass: "muted" }, [
                      _vm._v(
                        _vm._s(_vm.selectedFamily == "sharp" ? "sharp-" : "") +
                          _vm._s(_vm.makeDuotone ? "duotone-" : "") +
                          _vm._s(_vm.selectedStyle) +
                          "-"
                      ),
                    ]),
                    _c("span", [_vm._v(_vm._s(_vm.icon.name))]),
                    _c("span", { staticClass: "muted" }, [
                      _vm._v("-" + _vm._s(_vm.modName)),
                    ]),
                  ]),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "wrap-icon-wizard row roomy align-stretch" }, [
        _c(
          "div",
          {
            staticClass:
              "icon-wizard-grid-preview column-12 laptop:column-6 laptop:margin-bottom-0",
          },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.loading,
                    expression: "!loading",
                  },
                ],
                staticClass:
                  "display-flex flex-column flex-content-center position-relative align-stretch flex-content-between",
                staticStyle: { height: "100%", gap: "3rem" },
              },
              [
                _vm.isShowingDuotoneWarning
                  ? [
                      _c(
                        "div",
                        {
                          staticClass:
                            "card roomy icon-details-preview with-border with-border-radius flex-content-center display-flex flex-column flex-items-center flex-align-center margin-bottom-0",
                          staticStyle: {
                            height: "100%",
                            "--border-color": "var(--fa-lt-gravy)",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "icon-details-preview-rendering" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "padding-y-2xs",
                                  staticStyle: {
                                    opacity: "0.5",
                                    width:
                                      "var(--icon-details-preview-font-size)",
                                    margin: "0 auto",
                                    "font-size": "9rem",
                                  },
                                },
                                [
                                  _c("i", {
                                    class: `fa ${_vm.selectedFamily} fa-solid  fa-${_vm.icon.name}`,
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  : [
                      _vm.isProUser
                        ? [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "card roomy icon-details-preview with-border with-border-radius flex-content-center display-flex flex-column flex-items-center flex-align-center margin-bottom-0",
                                staticStyle: {
                                  height: "100%",
                                  "--border-color": "var(--fa-lt-gravy)",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "icon-details-preview-rendering",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          width:
                                            "var(--icon-details-preview-font-size)",
                                          margin: "0 auto",
                                          transform: "translateX(1.5rem)",
                                        },
                                      },
                                      [
                                        _vm.makeDuotone === false ||
                                        _vm.modType === ""
                                          ? _c(
                                              "svg",
                                              {
                                                staticStyle: {
                                                  fill: "var(--fa-navy)",
                                                  display: "block",
                                                  width: "100%",
                                                  height: "100%",
                                                },
                                                attrs: {
                                                  xmlns:
                                                    "http://www.w3.org/2000/svg",
                                                  viewBox: "0 0 640 640",
                                                },
                                              },
                                              [
                                                _c("path", {
                                                  attrs: { d: _vm.path },
                                                }),
                                              ]
                                            )
                                          : _c(
                                              "svg",
                                              {
                                                staticStyle: {
                                                  fill: "var(--fa-navy)",
                                                  display: "block",
                                                  width: "100%",
                                                  height: "100%",
                                                },
                                                attrs: {
                                                  xmlns:
                                                    "http://www.w3.org/2000/svg",
                                                  viewBox: "0 0 640 640",
                                                },
                                              },
                                              [
                                                _c("path", {
                                                  staticClass: "fa-primary",
                                                  attrs: { d: _vm.path },
                                                }),
                                                _vm._v(" "),
                                                _c("path", {
                                                  staticClass: "fa-secondary",
                                                  attrs: {
                                                    opacity: ".4",
                                                    d: _vm.secondaryPath,
                                                  },
                                                }),
                                              ]
                                            ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        : [
                            _c("icon-preview", {
                              attrs: {
                                "display-icon-preview-controls": false,
                                styling: _vm.defaultStyles,
                                icon: _vm.icon,
                                "default-styles": _vm.defaultStyles,
                                version: _vm.version,
                                "preview-mode": "day",
                              },
                            }),
                          ],
                    ],
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
              },
              [
                _c("wa-element-loading", {
                  staticClass:
                    "display-flex flex-column flex-items-center flex-content-center",
                  attrs: {
                    content: _vm.loadingMessage,
                    "custom-style": {
                      "min-height": "var(--element-sm-loading-min-height)",
                    },
                  },
                }),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "icon-wizard-use display-flex flex-column column-12 laptop:column-6 margin-bottom-2xl tablet:margin-bottom-0",
          },
          [
            _c("icon-family-style", {
              attrs: {
                icon: _vm.icon,
                styling: _vm.styling,
                version: _vm.version,
                "default-styles": _vm.defaultStyles,
              },
              on: { change: (value) => _vm.change(value) },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "card display-flex flex-column flex-content-between margin-bottom-0",
                style: _vm.summaryStyle,
              },
              [
                _vm.isShowingDuotoneWarning
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "display-flex flex-column flex-content-center",
                        staticStyle: { height: "100%" },
                      },
                      [_vm._m(0)]
                    )
                  : !_vm.loadingKits
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "display-flex flex-column flex-content-between",
                        staticStyle: { height: "100%" },
                      },
                      [
                        _vm.isProUser
                          ? [
                              _c(
                                "p",
                                { staticClass: "margin-bottom-md" },
                                [
                                  _vm._v(
                                    "\n              Add a modifier to the "
                                  ),
                                  _c("strong", [_vm._v(_vm._s(_vm.icon.name))]),
                                  _vm._v(
                                    " icon and save it directly to a Pro Kit of your choice. Use it just like any other\n              "
                                  ),
                                  _c(
                                    "site-link",
                                    {
                                      staticStyle: {
                                        "--link-color": "initial",
                                      },
                                      attrs: {
                                        to: _vm.$docs(
                                          "/web/add-icons/upload-icons"
                                        ),
                                      },
                                    },
                                    [_vm._v("custom uploaded icon")]
                                  ),
                                  _vm._v("!\n            "),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.isReady
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "wa-select-custom",
                                        {
                                          staticClass: "size-sm",
                                          attrs: {
                                            label:
                                              "Choose a Kit to add this icon to",
                                            "is-minimal": "",
                                            "custom-style": {
                                              "--input-font-weight":
                                                "var(--font-weight-normal)",
                                            },
                                          },
                                          on: {
                                            change: (value) =>
                                              _vm.onKitChange(value),
                                          },
                                        },
                                        [
                                          _c(
                                            "template",
                                            { slot: "options" },
                                            [
                                              _c(
                                                "option",
                                                { attrs: { value: "" } },
                                                [_vm._v("Select a Kit...")]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(_vm.kits, function (kit) {
                                                return _c(
                                                  "option",
                                                  {
                                                    key: kit.token,
                                                    domProps: {
                                                      value: kit.token,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(kit.name) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                )
                                              }),
                                            ],
                                            2
                                          ),
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "padding-top-xs" },
                                        [
                                          !_vm.uploading
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "button blue size-sm",
                                                  staticStyle: {
                                                    width: "100%",
                                                    "vertical-align": "center",
                                                  },
                                                  attrs: {
                                                    disabled: _vm.disableSave,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.saveIcon()
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("font-awesome-icon", {
                                                    staticClass:
                                                      "margin-right-3xs",
                                                    attrs: {
                                                      icon: _vm.$v6.solid
                                                        .faSuitcase,
                                                      size: "lg",
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "\n                  Save to Kit\n                "
                                                  ),
                                                ],
                                                1
                                              )
                                            : _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "button blue padding-y-lg",
                                                  staticStyle: {
                                                    width: "100%",
                                                    "vertical-align": "center",
                                                  },
                                                  attrs: { disabled: "true" },
                                                },
                                                [
                                                  _c("font-awesome-icon", {
                                                    staticClass:
                                                      "margin-right-3xs",
                                                    attrs: {
                                                      icon: _vm.$v6.regular
                                                        .faSync,
                                                      spin: "",
                                                      size: "lg",
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "\n                  Saving ...\n                "
                                                  ),
                                                ],
                                                1
                                              ),
                                          _vm._v(" "),
                                          _c(
                                            "dl",
                                            {
                                              staticClass:
                                                "display-flex flex-row flex-items-center flex-wrap margin-top-md",
                                              staticStyle: {
                                                gap: "var(--spacing-md)",
                                                "--list-line-height": "1.2",
                                                "--list-padding-left": "0",
                                              },
                                            },
                                            [
                                              _c(
                                                "dt",
                                                {
                                                  staticClass:
                                                    "margin-y-0 margin-right-0 size-sm",
                                                  staticStyle: {
                                                    "font-weight":
                                                      "var(--font-weight-normal)",
                                                  },
                                                },
                                                [
                                                  _c("font-awesome-icon", {
                                                    staticStyle: {
                                                      color: "var(--fa-blue)",
                                                    },
                                                    attrs: {
                                                      icon: _vm.$v6.solid
                                                        .faCircleInfo,
                                                      "fixed-width": "",
                                                      size: "lg",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "sr-only margin-left-2xs",
                                                    },
                                                    [_vm._v("Learn about… ")]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "dd",
                                                {
                                                  staticClass:
                                                    "margin-bottom-0 size-sm",
                                                },
                                                [
                                                  _c(
                                                    "site-link",
                                                    {
                                                      attrs: {
                                                        to: _vm.$docs(
                                                          "/web/add-icons/upload-icons"
                                                        ),
                                                      },
                                                    },
                                                    [_vm._v("Custom Icons")]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "dd",
                                                {
                                                  staticClass:
                                                    "margin-bottom-0 size-sm",
                                                },
                                                [
                                                  _c(
                                                    "site-link",
                                                    {
                                                      attrs: {
                                                        to: _vm.$docs(
                                                          "/web/add-icons/icon-wizard"
                                                        ),
                                                      },
                                                    },
                                                    [_vm._v("Icon Wizard")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _c("div", [
                                    _c(
                                      "p",
                                      [
                                        _c(
                                          "site-link",
                                          { attrs: { to: { name: "kits" } } },
                                          [_vm._v("Create a Pro Kit")]
                                        ),
                                        _vm._v(" to get started!"),
                                      ],
                                      1
                                    ),
                                  ]),
                            ]
                          : [
                              _c("div", [
                                _vm._m(1),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  [
                                    _vm._v(
                                      "\n                With the\n                "
                                    ),
                                    _c(
                                      "site-link",
                                      {
                                        staticStyle: {
                                          "--link-color": "initial",
                                        },
                                        attrs: {
                                          to: _vm.$docs(
                                            "/web/add-icons/icon-wizard"
                                          ),
                                        },
                                      },
                                      [_vm._v("Icon Wizard")]
                                    ),
                                    _vm._v(
                                      ", you can add an icon modifier the "
                                    ),
                                    _c("strong", [
                                      _vm._v(_vm._s(_vm.icon.name)),
                                    ]),
                                    _vm._v(
                                      " icon or any of our other icons with the click of a button. Save it\n                directly to a Pro Kit, and use it just like any other\n                "
                                    ),
                                    _c(
                                      "site-link",
                                      {
                                        staticStyle: {
                                          "--link-color": "initial",
                                        },
                                        attrs: {
                                          to: _vm.$docs(
                                            "/web/add-icons/upload-icons"
                                          ),
                                        },
                                      },
                                      [_vm._v("custom uploaded icon")]
                                    ),
                                    _vm._v("!\n              "),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "text-center" },
                                [
                                  _c(
                                    "site-link",
                                    {
                                      staticClass:
                                        "button block accent margin-top-md",
                                      attrs: { to: { name: "plans" } },
                                    },
                                    [
                                      _vm._v(
                                        "Get a Pro Plan + Use the Icon Wizard"
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    { staticClass: "size-sm margin-top-lg" },
                                    [
                                      _vm._v(
                                        "\n                Already have a Pro Plan?\n                "
                                      ),
                                      _c(
                                        "site-link",
                                        {
                                          staticClass: "margin-left-2xs",
                                          staticStyle: {
                                            "--link-color": "initial",
                                          },
                                          attrs: {
                                            to: {
                                              name: "sessions.sign-in",
                                              query: { next: _vm.signInNext },
                                            },
                                          },
                                          nativeOn: {
                                            click: function ($event) {
                                              return _vm.$posthog.capture(
                                                "sign_in_button_click",
                                                { context: "icon_wizard_modal" }
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Sign in\n                  "
                                          ),
                                          _c("font-awesome-icon", {
                                            attrs: {
                                              icon: _vm.$v6.regular
                                                .faRightToBracket,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                      ],
                      2
                    )
                  : _c("wa-element-loading", {
                      staticClass:
                        "display-flex flex-column flex-items-center flex-content-center",
                      attrs: {
                        content: _vm.loadingMessage,
                        "custom-style": {
                          height: "100%",
                          color: "var(--fa-navy)",
                        },
                      },
                    }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "icon-wizard-modifiers display-flex position-relative column-12 margin-top-xl margin-bottom-xl laptop:margin-bottom-0",
          },
          [
            _c(
              "div",
              {
                staticClass: "display-flex flex-row flex-wrap",
                staticStyle: { gap: "var(--spacing-sm)" },
                attrs: { id: "chooser" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "buttons",
                    staticStyle: {
                      "flex-grow": "3",
                      "--button-margin-bottom": "0",
                      "--button-padding": "var(--spacing-xs)",
                      "--button-background": "var(--fa-lt-gravy)",
                      "--button-color": "var(--fa-navy)",
                    },
                  },
                  [
                    _c(
                      "button",
                      {
                        class: [
                          "checkbox-make-duotone flat compact with-border",
                          { active: _vm.makeDuotone },
                        ],
                        staticStyle: { "line-height": "1" },
                        attrs: {
                          disabled:
                            _vm.isShowingDuotoneWarning || !_vm.isProUser,
                          "aria-label": "Make it Duotone",
                          "data-balloon-pos": "up",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.toggleDuotone()
                          },
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.$v6.duotone.faCircleHalf,
                            size: "xl",
                            transform: { rotate: 45 },
                            "fixed-width": "",
                          },
                        }),
                        _vm._v(" "),
                        _vm.makeDuotone
                          ? _c("span", { staticClass: "sr-only" }, [
                              _vm._v("Duotone-mode on"),
                            ])
                          : _c("span", { staticClass: "sr-only" }, [
                              _vm._v("Duotone-mode off"),
                            ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        class: `icon-action-modifier flat compact with-border ${
                          _vm.modified === false ? "" : ""
                        }`,
                        staticStyle: { "line-height": "1" },
                        attrs: {
                          disabled:
                            _vm.isShowingDuotoneWarning || !_vm.isProUser,
                          "aria-label": "Remove modifier",
                          "data-balloon-pos": "up",
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.showOriginal()
                          },
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.$v6.solid.faBan,
                            size: "xl",
                            "fixed-width": "",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm._l(_vm.iconModifers, function (mod) {
                  return _c(
                    "button",
                    {
                      key: mod.type,
                      class: `icon-action-modifier flat compact size-xs display-inline-block ${
                        mod.type == _vm.modType ? "active" : ""
                      }`,
                      staticStyle: {
                        "--button-margin-bottom": "0",
                        "--button-padding": "var(--spacing-xs)",
                        "--button-hover-background": "var(--fa-lt-gravy)",
                        "--button-hover-color": "var(--fa-dk-blue)",
                        "line-height": "1",
                      },
                      attrs: {
                        disabled: _vm.isShowingDuotoneWarning || !_vm.isProUser,
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.modifyIcon(mod.type)
                        },
                      },
                    },
                    [
                      _c("i", {
                        class: `${_vm.modifierFamily} fa-${_vm.modifierStyle} fa-2x fa-fw ${mod.icon}`,
                      }),
                    ]
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            !_vm.isProUser
              ? _c("site-link", {
                  staticStyle: {
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    top: "0",
                    left: "0",
                  },
                  attrs: {
                    to: { name: "plans" },
                    "aria-label": "Go Pro to Use the Icon Wizard!",
                    "data-balloon-pos": "up",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("customize-alerts", {
        attrs: {
          id: "alerts",
          loading: _vm.loading || _vm.loadingKits,
          "error-message": _vm.errorMessage,
          kits: _vm.kits,
          "selected-kit": _vm.selectedKit,
          "icon-name": _vm.iconName,
          "duplicate-error": _vm.duplicate,
          success: _vm.success,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-center" }, [
      _c("h3", { staticClass: "margin-y-xs" }, [_vm._v("Sorry!")]),
      _vm._v(" "),
      _c("p", [_vm._v("Icon Modifiers aren't ready for Duotone yet…")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "display-flex flex-row flex-content-between margin-bottom-sm",
      },
      [
        _c("h3", { staticClass: "h5 margin-0" }, [_vm._v("Icon Wizard")]),
        _vm._v(" "),
        _c("span", { staticClass: "tag yellow" }, [_vm._v("Pro")]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }